export default __webpack_public_path__ + "static/media/404.6d68a4bc.jpg";